/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  ContextFeatureFlagAPIData
} from '../../model/contextFeatureFlagAPIData'
import type {
  FeatureFlagEditDataRequest
} from '../../model/featureFlagEditDataRequest'
import type {
  FeatureFlagReadData
} from '../../model/featureFlagReadData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get individual feature flag data.
 */
export const featureFlagRetrieve = (
    featureFlagId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeatureFlagReadData>(
      {url: `/feature-flags/${featureFlagId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeatureFlagRetrieveQueryKey = (featureFlagId: string,) => {
    return [`/feature-flags/${featureFlagId}/`] as const;
    }

    
export const getFeatureFlagRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagRetrieve>>, TError = unknown>(featureFlagId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagRetrieveQueryKey(featureFlagId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagRetrieve>>> = ({ signal }) => featureFlagRetrieve(featureFlagId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeatureFlagRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagRetrieve>>>
export type FeatureFlagRetrieveQueryError = unknown

export const useFeatureFlagRetrieve = <TData = Awaited<ReturnType<typeof featureFlagRetrieve>>, TError = unknown>(
 featureFlagId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeatureFlagRetrieveQueryOptions(featureFlagId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeatureFlagRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof featureFlagRetrieve>>, TError = unknown>(featureFlagId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeatureFlagRetrieveQueryKey(featureFlagId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof featureFlagRetrieve>>> = ({ signal }) => featureFlagRetrieve(featureFlagId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(featureFlagId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeatureFlagRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof featureFlagRetrieve>>>
export type FeatureFlagRetrieveSuspenseQueryError = unknown

export const useFeatureFlagRetrieveSuspense = <TData = Awaited<ReturnType<typeof featureFlagRetrieve>>, TError = unknown>(
 featureFlagId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof featureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeatureFlagRetrieveSuspenseQueryOptions(featureFlagId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeatureFlagRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ featureFlagId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { featureFlagId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (featureFlagId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeatureFlagRetrieveQueryKey(featureFlagId),
              queryFn: () => featureFlagRetrieve(featureFlagId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * This endpoint edits a specific environment level feature flag via SuperBlocks.
 */
export const featureFlagUpdate = (
    featureFlagId: string,
    featureFlagEditDataRequest: FeatureFlagEditDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeatureFlagReadData>(
      {url: `/feature-flags/${featureFlagId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: featureFlagEditDataRequest
    },
      options);
    }
  


export const getFeatureFlagUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagUpdate>>, TError,{featureFlagId: string;data: FeatureFlagEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof featureFlagUpdate>>, TError,{featureFlagId: string;data: FeatureFlagEditDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof featureFlagUpdate>>, {featureFlagId: string;data: FeatureFlagEditDataRequest}> = (props) => {
          const {featureFlagId,data} = props ?? {};

          return  featureFlagUpdate(featureFlagId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeatureFlagUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof featureFlagUpdate>>>
    export type FeatureFlagUpdateMutationBody = FeatureFlagEditDataRequest
    export type FeatureFlagUpdateMutationError = unknown

    export const useFeatureFlagUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof featureFlagUpdate>>, TError,{featureFlagId: string;data: FeatureFlagEditDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeatureFlagUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * This endpoint returns all feature flags for a customer for rendering views in the Frontend.
 */
export const contextFeatureFlagRetrieve = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<ContextFeatureFlagAPIData>(
      {url: `/feature-flags/context/`, method: 'GET', signal
    },
      options);
    }
  

export const getContextFeatureFlagRetrieveQueryKey = () => {
    return [`/feature-flags/context/`] as const;
    }

    
export const getContextFeatureFlagRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContextFeatureFlagRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>> = ({ signal }) => contextFeatureFlagRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ContextFeatureFlagRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>>
export type ContextFeatureFlagRetrieveQueryError = unknown

export const useContextFeatureFlagRetrieve = <TData = Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getContextFeatureFlagRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContextFeatureFlagRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContextFeatureFlagRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>> = ({ signal }) => contextFeatureFlagRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ContextFeatureFlagRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>>
export type ContextFeatureFlagRetrieveSuspenseQueryError = unknown

export const useContextFeatureFlagRetrieveSuspense = <TData = Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contextFeatureFlagRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getContextFeatureFlagRetrieveSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getContextFeatureFlagRetrieveLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getContextFeatureFlagRetrieveQueryKey(),
          queryFn: () => contextFeatureFlagRetrieve(),
        }).then(() => null));
      